import {
    scaffolderPlugin,
    createScaffolderFieldExtension,
  } from '@backstage/plugin-scaffolder';
  import { TerraformRepoPicker, terraformRepoPickerValidation } from './TerraformRepoPickerExtension';
  
  export const TerraformRepoPickerExtension = scaffolderPlugin.provide(
    createScaffolderFieldExtension({
      name: 'TerraformRepoPickerExtension',
      component: TerraformRepoPicker,
      validation: terraformRepoPickerValidation,
    }),
  );